<template>
  <div class="login-page">
    <div class="logo">
      <a href="#">
        <img src="@/assets/i/logoClaim.png" alt="logo" />
      </a>
    </div>
    <div class="login-bg">
      <div class="row d-flex justify-content-center">
        <div class="col-md-12">
          <div class="login-box">
            <h2>Acceso</h2>
            <div class="form" @keyup.13="onSubmit">
              <div class="form-item">
                <v-text-field
                  :label="$t('lang.login.input_placeholder_username')"
                  outlined
                  type="text"
                  :error="user.error"
                  v-model="user.value"
                ></v-text-field>
              </div>
              <div class="form-item">
                <v-text-field
                  :label="$t('lang.login.input_placeholder_password')"
                  :error="password.error"
                  outlined
                  type="password"
                  v-model="password.value"
                ></v-text-field>
              </div>
              <hr />
              <bx-notification
                ref="errorNotification"
                color="danger"
                closable
                novisible
                timeout="5000"
                block
              ></bx-notification>

              <bx-btn color="primary submit-btn" big block @click="onSubmit"
                >Login</bx-btn
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copy-text">
      <p>©2024 Kyubi System</p>
    </div>
  </div>
</template>

<script>
import BxNotification from "../bx-components/BxNotification";
export default {
  name: "home",
  components: { BxNotification },
  data() {
    return {
      mounted: false,
      user: {
        value: "", // process.env.NODE_ENV === 'development' ? 'opsou' : '',
        error: false
      },
      password: {
        value: "", // process.env.NODE_ENV === 'development' ? '0ps0ud3v' : '',
        error: false
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.mounted = true;
    });
  },
  methods: {
    validateForm() {
      let valid = true;
      if (this.user.value === "") {
        this.user.error = true;
        valid = false;
      }

      if (this.password.value === "") {
        this.password.error = true;
        valid = false;
      }

      return valid;
    },
    onSubmit() {
      if (this.validateForm()) {
        this.$api.auth
          .login(this.user.value, this.password.value)
          .then(() => {
            this.$router.push({ name: "dashboard" });
          })
          .catch(error => {
            const errorKey = Object.keys(error.response.data)[0];
            this.$refs["errorNotification"].showNotification(
              error.response.data[errorKey][0]
            );
          });
      }
    }
  }
};
</script>
